export const borderWidths = {
  thinner: '0.5px',
  thin: '0.75px',
  default: '1px',
  thick: '2px',
  thicker: '4px'
}

export type BorderWidthThemeKeys = keyof typeof borderWidths
